import {
  CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT,
  CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS,
  CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES,
} from './CalendarSettings.constants'

export function getCalendarSettingsTaskTypeFieldName(type) {
  return `${CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES}.${type.id}`
}

export function getCalendarSettingsInitialValues(settings) {
  return {
    [CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT]:
      settings[CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT],
    [CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS]:
      settings[CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS],
    [CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES]: Object.fromEntries(
      settings[CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES].map(type => [
        type.id,
        type.calendar_relevant,
      ])
    ),
  }
}

export function getCalendarSettingsPayload({ settings, values }) {
  return {
    [CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT]:
      values[CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT],
    [CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS]:
      values[CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS],
    [CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES]: settings[
      CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES
    ].map(type => ({
      ...type,
      calendar_relevant:
        values[CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES][type.id],
    })),
  }
}
